import { ImageFragment } from '@/graphql/fragments/image';
import { ResourceBaseFragment } from '@/graphql/fragments/resource';
import { gql } from '@apollo/client';

export const QUERY_RESOURCE = gql`
  query resource($slug: [String]) {
    resources(pagination: { limit: 1 }, sort: "publicationDate:desc", filters: { slug: { in: $slug } }) {
      data {
        id
        attributes {
          title
          slug
          duration
          briefDescription
          resourceType {
            data {
              attributes {
                type
              }
            }
          }
          subHeader
          cover {
            data {
              ...ImageFragment
            }
          }
          themes {
            data {
              id
              attributes {
                theme
                topic {
                  data {
                    id
                    attributes {
                      topic
                    }
                  }
                }
              }
            }
          }
          DefaultContentTemplate {
            __typename
            ... on ComponentCommonH3 {
              text
            }
            ... on ComponentCommonMedia {
              media {
                data {
                  attributes {
                    url
                    alternativeText
                  }
                }
              }
            }
            ... on ComponentCommonTitle {
              title
            }

            ... on ComponentCommonAuthorDetailed {
              authors {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }

            ... on ComponentKnowledgeHubResourcesRelated {
              resources {
                data {
                  attributes {
                    ...ResourceBaseFragment
                  }
                }
              }
            }

            ... on ComponentCommonDivider {
              id
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonTextEditor {
              markdownText
            }

            ... on ComponentCommonEmbedded {
              link
              provider
            }

            ... on ComponentCommonBullet {
              item {
                text
              }
            }

            ... on ComponentCommonQuote {
              quote
            }

            ... on ComponentCommonFaqComponent {
              faq {
                title
                description
              }
            }
            ... on ComponentCommonTags {
              id
            }
            ... on ComponentCommonRelatedContent {
              id
            }

            ... on ComponentCommonDownloadableContentList {
              list {
                title
                description
                content {
                  data {
                    attributes {
                      url
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_RESOURCES_PAGEABLE = gql`
  query fetchLatestResourcesPageable($kinds: [String], $page: Int!, $search: String, $theme: String, $topic: String) {
    resources(
      pagination: { pageSize: 8, page: $page }
      sort: "publicationDate:desc"
      filters: {
        title: { containsi: $search }
        resourceType: { type: { in: $kinds } }
        themes: { theme: { eq: $theme }, topic: { topic: { eq: $topic } } }
      }
    ) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCES = gql`
  query fetchLatestResources($slug: [String]) {
    resources(pagination: { limit: 2 }, sort: "publicationDate:desc", filters: { slug: { notIn: $slug } }) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_LATEST_RESOURCE_BY_TYPE = gql`
  query highlights {
    knowledgeHubPage {
      data {
        attributes {
          highlights {
            data {
              attributes {
                ...ResourceBaseFragment
              }
            }
          }
        }
      }
    }
  }
  ${ResourceBaseFragment}
`;
